<div class="column main-container space-top-2">
  <span class="title">{{ 'supporting_documents.error.title' | translate }}</span>
  <span class="subtitle">{{ 'supporting_documents.error.subtitle' | translate }}</span>
  <button mat-flat-button color="primary" [routerLink]="['../mobi-sub']">
    {{ 'supporting_documents.error.back-btn' | translate }}
  </button>
</div>
